import {atom, useSetRecoilState} from "recoil";
import {KEYS} from "@/app/constants/keys";
import {SpaceStateModel} from "@/contents/models/spaceModel";
import {LoginInfo} from "@contents/models/authModel";
import {ShopEntity} from "@services/entities/shopEntity";
import {recoilPersist} from "@utils/persist";
import {EnumTypeEntity} from "@services/entities/configEntity";
import {BrandEntity} from "@services/entities/brandEntity";
import {MemberMeModel} from "@contents/models/memberModel";
import {ShopCopySaveModel} from "@contents/models/commonModel";

const { persistAtom } = recoilPersist();

export const spaceNameState = atom<string>({
  key: KEYS.ATOM.spaceName,
  default: "",
  effects_UNSTABLE: [persistAtom]
});

export const loginState = atom<LoginInfo>({
  key: KEYS.ATOM.userState,
  default: {
    isLogin: false,
    accessToken: "",
    refreshToken: "",
    tokenType: "",
    ssoToken: "",
    loginType: "",
  },
  effects_UNSTABLE: [persistAtom]
});

export const spaceState = atom<SpaceStateModel>({
  key: KEYS.ATOM.spaceState,
  default: {
    space: sessionStorage.getItem(KEYS.SPACE_NAME) ?? '',
    brandCode: sessionStorage.getItem(KEYS.BRAND_CODE) ?? '',
    brandId: 0,
    selectedShopId: 0,
    selectedOperation: "OP",
    selectedTopMenu: "",
    activeRoute: "",
    deviceInfo: '',
  },
  effects_UNSTABLE: [persistAtom]
});

export const brandState = atom<BrandEntity>({
  key: KEYS.ATOM.brandState,
  default: {},
  effects_UNSTABLE: [persistAtom]
})

export const memberState = atom<MemberMeModel>({
  key: KEYS.ATOM.memberState,
  default: {
    id: 0,
    userId: '',
    name: '',
    email: '',
    activationType: false,
    brandCode: '',
    roles: [],
    shops: [],
    companies: [],
    regAt: ''
  },
  effects_UNSTABLE: [persistAtom]
});

export const shopState = atom<ShopEntity>({
  key: KEYS.ATOM.shopState,
  default: {
    id: 0,
    type: "CAFE",
    name: {},
    mobileOpenAt: "",
  },
  effects_UNSTABLE: [persistAtom]
});

// playerType enum
export const playerState = atom<Array<EnumTypeEntity>>({
  key: KEYS.ATOM.playerType,
  default: [],
  effects_UNSTABLE: [persistAtom]
})

export const loadingState = atom<boolean>({
  key: KEYS.ATOM.loadingState,
  default: false,
})

export const mainMenuState = atom<boolean>({
  key: KEYS.ATOM.mainMenuState,
  default: false,
})

export const isShopCopyState = atom<boolean>({
  key: KEYS.ATOM.shopCopyState,
  default: false
})

export const isAccessModalState = atom<boolean>({
    key: KEYS.ATOM.accessModalState,
    default: false,
})

let _setAccessModalState: (v: boolean) => void;

export const AccessModalStateSetter = () => {
    _setAccessModalState = useSetRecoilState(isAccessModalState);
    return null;
};

export const setAccessModalState = (v: boolean) => {
    if (_setAccessModalState) _setAccessModalState(v);
};

